import revive_payload_client_4sVQNw7RlN from "F:/webroot/abuy.ilovearomagrace.com/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "F:/webroot/abuy.ilovearomagrace.com/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "F:/webroot/abuy.ilovearomagrace.com/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "F:/webroot/abuy.ilovearomagrace.com/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "F:/webroot/abuy.ilovearomagrace.com/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "F:/webroot/abuy.ilovearomagrace.com/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "F:/webroot/abuy.ilovearomagrace.com/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import element_plus_teleports_plugin_h4Dmekbj62 from "F:/webroot/abuy.ilovearomagrace.com/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "F:/webroot/abuy.ilovearomagrace.com/.nuxt/element-plus-injection.plugin.mjs";
import chunk_reload_client_UciE0i6zes from "F:/webroot/abuy.ilovearomagrace.com/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "F:/webroot/abuy.ilovearomagrace.com/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ
]